import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'UIComponents/elements/headings';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UIList from 'UIComponents/list/UIList';
const FeatureHighlightsConfig = [{
  featureName: 'invoices',
  featureIcon: 'invoices'
}, {
  featureName: 'paymentLinks',
  featureIcon: 'payments-button'
}, {
  featureName: 'quotes',
  featureIcon: 'quotes'
}];

const FeatureHighlight = ({
  featureName,
  featureIcon
}) => {
  return /*#__PURE__*/_jsx(UIMediaObject, {
    itemLeft: /*#__PURE__*/_jsx(UIIllustration, {
      name: featureIcon,
      width: "75px"
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: "m-left-6",
      children: [/*#__PURE__*/_jsx(H7, {
        "aria-level": 3,
        className: "m-bottom-2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `pricingPage.pages.commerce.featureHighlights.${featureName}.title`
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.pages.commerce.featureHighlights.${featureName}.description`
      })]
    })
  });
};

export const BringCommerceFeatureHighlights = () => {
  return /*#__PURE__*/_jsx(UIList, {
    childClassName: "m-bottom-8",
    children: FeatureHighlightsConfig.map(({
      featureName,
      featureIcon
    }) => /*#__PURE__*/_jsx(FeatureHighlight, {
      featureName: featureName,
      featureIcon: featureIcon
    }, featureName))
  });
};